// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"ef0719fe","345":"a8f51882","548":"2a696ac5"}[chunkId] + ".chunk.css";
};